"use client";
import React from "react";
import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import { usePrevious } from "../../hooks/previousValueCheck";
import { WcDatePicker } from "../WcDatePicker/WcDatePicker";
import { PickersDay, PickersDayProps } from "@mui/x-date-pickers/PickersDay";
import dayjs, { Dayjs } from "dayjs";
import isBetween from "dayjs/plugin/isBetween";
dayjs.extend(isBetween);

export interface WeekPickerProps {
  onSelectedDateValueChanged: any;
  currentValue: any;
}

export const WcWeekPicker = ({ onSelectedDateValueChanged, currentValue }: WeekPickerProps) => {
  const [currentSelectedDate, setCurrentSelectedDate] = React.useState(dayjs(currentValue));
  const prevValue = usePrevious(currentValue);

  const handleWeekChange = (date: any) => {
    //@ts-ignore
    setCurrentSelectedDate(dayjs(date).startOf("week"));
    //@ts-ignore
    onSelectedDateValueChanged(dayjs(date).startOf("week"));
  };

  React.useEffect(() => {
    if (currentValue !== prevValue) {
      setCurrentSelectedDate(currentValue);
    }
  }, [currentValue]);

  interface CustomPickerDayProps extends PickersDayProps {
    dayIsBetween: boolean;
    isFirstDay: boolean;
    isLastDay: boolean;
  }

  const CustomPickersDay = styled(PickersDay, {
    shouldForwardProp: (prop) => prop !== "dayIsBetween" && prop !== "isFirstDay" && prop !== "isLastDay",
  })<CustomPickerDayProps>(({ theme, dayIsBetween, isFirstDay, isLastDay }) => ({
    ...(dayIsBetween && {
      borderRadius: 0,
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.common.white,
      "&:hover, &:focus": {
        backgroundColor: theme.palette.primary.dark,
      },
    }),
    ...(isFirstDay && {
      borderTopLeftRadius: "50%",
      borderBottomLeftRadius: "50%",
    }),
    ...(isLastDay && {
      borderTopRightRadius: "50%",
      borderBottomRightRadius: "50%",
    }),
  })) as React.ComponentType<CustomPickerDayProps>;

  const renderWeekPickerDay = (props: PickersDayProps & { selectedDay?: Dayjs | null }) => {
    dayjs.extend(isBetween);
    const { day: dateObjDay, selectedDay, ...other } = props;
    const day = dayjs(dateObjDay);
    if (selectedDay == null) {
      //@ts-ignore
      return <PickersDay day={day} {...other} />;
    }
    console.log(day);
    const start = currentSelectedDate.startOf("week");
    const end = currentSelectedDate.endOf("week");

    const dayIsBetween = day.isBetween(start, end, null, "[]");
    const isFirstDay = day.isSame(start, "day");
    const isLastDay = day.isSame(end, "day");

    return (
      <CustomPickersDay {...other} day={day} disableMargin dayIsBetween={dayIsBetween} isFirstDay={isFirstDay} isLastDay={isLastDay} />
    );
  };

  return (
    <Box minWidth={150}>
      <WcDatePicker
        label="Week picker"
        value={currentSelectedDate}
        disabled={false}
        onChange={(newValue) => handleWeekChange(newValue)}
        //@ts-ignore
        slots={{ day: renderWeekPickerDay }}
        slotProps={{ day: { selectedDay: currentSelectedDate } as any }}
      />
    </Box>
  );
};

export default WcWeekPicker;
